import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { HttpStatusCode } from "axios";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { PostShouldDisplayResponseDto } from "../../../types/dto/app/post-should-display-response-dto";
import { CONSENT_FLAG_KEY } from "../../../../application/hooks/heartbeat/use-heartbeat";
import { RequestNudgeType } from "../../../../application/utils/request-nudge-type";
import { setCustomCalendar, setIsChattingWithLiveAgent, setReqNudgeConfig } from "../../chat/chat-slice";
import { setHeartbeatThreshold } from "../app-state-slice";

export const shouldDisplay = createAsyncThunk<
  PostShouldDisplayResponseDto | null
>(
  "app-state-slice/should-display",
  async (
    _,
    { getState, rejectWithValue, fulfillWithValue, dispatch }
  ) => {

    const state = getState() as RootState;

    const { merchId, sessionId, suId, conversationId } = state["app-state"];

    const response = await axiosClient.post<PostShouldDisplayResponseDto>('/shouldidisplay', {
      url: window.location.href,
      cust_id: merchId,
      su_id: suId,
      conversation_id: conversationId,
      session_id: sessionId,
      closeWidget: true,
      nudge_type: state.chat.reqNudgeType
    });

    if (response.data.nudge_config){
      dispatch(setReqNudgeConfig(response.data.nudge_config));
    }
    if (response.data.consent_flag) {
      localStorage.setItem(CONSENT_FLAG_KEY, 'true');
    } else {
      localStorage.removeItem(CONSENT_FLAG_KEY);
    }
    if (response.data.should_currently_show_live_agent_connections_quick_action_buttons){
      dispatch(setIsChattingWithLiveAgent(true));
    } else{
      dispatch(setIsChattingWithLiveAgent(false));
    }
    if (response.data.heartbeat_threshold){
      dispatch(setHeartbeatThreshold(response.data.heartbeat_threshold));
    }
    if (response.data.custom_calendar){
      dispatch(setCustomCalendar(true));
    } else{
      dispatch(setCustomCalendar(false));
    }
    if (response.status !== HttpStatusCode.Ok) {
      return rejectWithValue((response.data));
    }
    return fulfillWithValue(response.data);
  }
);
